import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { NbRoleProvider } from '@nebular/security';
import { Observable, of } from 'rxjs';


@Injectable()
export class RoleProviderService implements NbRoleProvider, CanActivate {
  token: any;
  rol = 'user';
  header: any;
  clientInfo: any;

  constructor(private router: Router, private authService: NbAuthService, private http: HttpClient) {

  }

  getRole(): Observable<string[]> {
    return of([this.rol]);

  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRole = route.data.expectedRole;

    if (this.rol !== expectedRole) {

      this.router.navigate(['/404']);
      return false;
    }
    return true;
  }
}
